import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PersonalParticularReducer } from '../reducers';

export const selectPersonalParticularFeature = createFeatureSelector<PersonalParticularReducer.PersonalParticularState>('personalParticular');

export const selectPersonalParticularDetail = createSelector(
  selectPersonalParticularFeature,
  (state: PersonalParticularReducer.PersonalParticularState) => state.detail
);
